export default __webpack_public_path__ + "static/media/vip.67f1a0d9.png";